import { Box } from '@mui/material';
import { styled } from '@mui/system';

export const CompanyAvailabilityTableHeaderContainer = styled(Box)(({ theme }) => ({
  height: '100px',
  display: 'flex',
  padding: `${theme.spacing(1)} 0`,
}));
